"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomErrMsgDialog_1 = require("./CustomErrMsgDialog");
exports.default = CustomErrMsgDialog_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/CustomErrMsgDialog/index.js
// module id = 1138
// module chunks = 8